import type { FleetOperationalStatus } from '@gb-ticket/shared-types';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { FLEET_STATUS_LABELS } from '@/products/fleet/features/fleet-labels';

const FLEET_STATUS_BADGE_CLASS: Record<FleetOperationalStatus, string> = {
  in_service: 'border-status-success-border bg-status-success text-status-success-foreground',
  out_of_service: 'border-status-danger-border bg-status-danger text-status-danger-foreground',
  in_workshop: 'border-status-warning-border bg-status-warning text-status-warning-foreground',
  retired: 'border-status-neutral-border bg-status-neutral text-status-neutral-foreground',
};

export function FleetStatusBadge({ status }: { status: FleetOperationalStatus }) {
  return (
    <Badge variant="outline" className={cn(FLEET_STATUS_BADGE_CLASS[status])}>
      {FLEET_STATUS_LABELS[status]}
    </Badge>
  );
}
